<app-header [search]="true" [enableBack]="false">
  <div title>
    {{ 'meteringpoint.title' | translate }}
  </div>
</app-header>
<div class="p-6">
  <form [formGroup]="searchForm">
    <app-card>
      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.search.meteringPointID' | translate}}</label>
            <input type="text" appInput autofocus formControlName="identification" [placeholder]="'meteringPoint.search.meteringPointID' | translate" />
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.search.meteringPointType' | translate }}</label>
            <select appSelect formControlName="meteringPointType" [collection]="meteringPointTypeOptions">
            </select>
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.search.physicalStatus' | translate }}</label>
            <select appSelect formControlName="physicalStatus" [collection]="physicalStatusOptions">
            </select>
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.search.meterNumber' | translate }}</label>
            <input type="text" appInput formControlName="meterNumber" [placeholder]="'meteringPoint.search.meterNumber' | translate" />
          </app-input-group>
        </div>
      </div>

      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'address.streetName' | translate }}</label>
            <input type="text" appInput formControlName="streetName" [placeholder]="'address.streetName' | translate" />
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'address.houseNumber' | translate }}</label>
            <input type="text" appInput formControlName="buildingNumber" [placeholder]="'address.houseNumber' | translate" />
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'address.floor' | translate }}</label>
            <input type="text" appInput formControlName="floorIdentification" [placeholder]="'address.floor' | translate" />
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'address.zipCode' | translate }}</label>
            <input appInput inputmode="numeric" pattern="[0-9]*" formControlName="postalCode" [placeholder]="'address.zipCode' | translate" />
          </app-input-group>
        </div>
      </div>
      <div class="flex gap-2 align-middle">
        <button appButton (click)="performSearch()">
          {{ 'common.search' | translate }}
        </button>
        <button appButton type="tertiary" (click)="clearForm()">{{ 'common.reset' | translate }}</button>
      </div>
    </app-card>
  </form>

  <app-table
    #table
    [config]="meterTableConfig"
    [(selectedElements)]="selectedElements"
  ></app-table>
</div>
